// 서버에서 클라이언트로 보내는 이벤트 (수신)
export const WsListenerEvent = {
  OPEN: 'open',
  CONNECTED: 'connected',
  TEXT_CHUNK: 'text_chunk',
  CHUNK: 'chunk',
  ERROR: 'error',
  INTERRUPTED: 'interrupted',
  CLOSE: 'close',
  PONG: 'pong',
  AVATAR_SETUP_COMPLETE: 'avatar_setup_complete',
  REAUTH_REQUIRED: 'session.reauth_required',
  STT_RESULT: 'stt_result',
  INACTIVE_WARNING: 'inactive_warning',
  DISCONNECT_NOTICE: 'disconnect_notice',
} as const;

// 클라이언트에서 서버로 보내는 메시지 타입 (송신)
export const WsMessageType = {
  MESSAGE: 'message',
  AVATAR_SETUP: 'avatar_setup',
  INTERRUPT: 'interrupt',
  PING: 'ping',
} as const;

// 메시지 모드 타입
export const MessageMode = {
  TEXT: 'text',           // TTS + 립싱크
  VOICE: 'voice',         // 음성 입력
  TEXT_ONLY: 'text_only', // 텍스트만
} as const;

export type WsListenerEventType = typeof WsListenerEvent[keyof typeof WsListenerEvent];
export type WsMessageTypeType = typeof WsMessageType[keyof typeof WsMessageType];
export type MessageModeType = typeof MessageMode[keyof typeof MessageMode];
